export default __webpack_public_path__ + "static/media/puta.b0d342cc.mp4";